import type { ReactNode } from 'react';

export const symbol_settings_applications: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m442-340 6 32q2 10 9.5 16t17.5 6h10q10 0 17.5-6.5T512-309l6-31q20-6 34-15t26-21l38 12q11 3 20.5-1.5T651-380l4-7q5-11 2-21.5T644-425l-25-16q4-21 4-39t-4-39l25-16q10-6 13-17t-2-21l-4-7q-5-10-14.5-14.5T616-596l-38 12q-12-12-26-21t-34-15l-6-32q-2-10-9.5-16t-17.5-6h-10q-10 0-17.5 6.5T448-651l-6 31q-20 6-34 15t-26 21l-38-12q-11-3-20.5 1.5T309-580l-4 7q-5 11-2 21.5t13 16.5l25 16q-4 21-4 39t4 39l-25 16q-10 6-13 17t2 21l4 7q5 10 14.5 14.5T344-364l38-12q12 12 26 21t34 15Zm-22.5-79.5Q395-444 395-480t24.5-60.5Q444-565 480-565t60.5 24.5Q565-516 565-480t-24.5 60.5Q516-395 480-395t-60.5-24.5ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
